/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  Grid,
  IconButton
} from '@mui/material';
import { CancelPresentationRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import styles from './styles';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ModalDialog from '../../ModalDialog';
import { REPORT_INPUT_LIST } from '../../../../utils/constants';

const ReportInputsModal = ({
  onCloseClick,
  isOpen,
  tableList,
  setTableList,
  generateReport
}) => {
  const classes = styles();
  const apiRef = useGridApiRef();

  const getModalTitle = () => (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        {'Report Inputs Include'}
      </Grid>
      <Grid item>
        <IconButton onClick={onCloseClick}>
          <CancelPresentationRounded fontSize='large' />
        </IconButton>
      </Grid>
    </Grid>
  );

  if (apiRef.current === null) apiRef.current = {};

  return (
    <ModalDialog
      title={getModalTitle()}
      isOpen={isOpen}
      onClose={onCloseClick}
      dialogClass={classes.dialogModal}
    >
        <Box marginTop='1%' marginLeft='2.5%'>
          {REPORT_INPUT_LIST.map((item) => (
            <Box key={item.key}>
              <FormControlLabel
                control={
                  <Checkbox
                    value={item.key}
                    checked={tableList.includes(item.key)}
                    onChange={(e) => {
                      const { checked, value } = e.target;
                      setTableList((prev) =>
                        checked ? [...prev, value] : prev.filter((i) => i !== value)
                      );
                    }}
                  />
                }
                label={item.label}
                sx={{
                  '.MuiFormControlLabel-label': {
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                  marginTop: '4px',
                }}
              />
            </Box>
          ))}
        </Box>
      <Grid container item justifyContent='center' marginBottom='1rem'>
          <DialogActions>
            <Button
              style={{ backgroundColor: '#444', width: '150px', color: '#fff' }}
              onClick={() => {
                onCloseClick();
                generateReport();
              }}
            >
              Generate Report
            </Button>
          </DialogActions>
      </Grid>
    </ModalDialog>
  );
};

ReportInputsModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  rowData: PropTypes.object,
  tableList: PropTypes.any,
  setTableList: PropTypes.any,
  generateReport: PropTypes.any
};

export default ReportInputsModal;
